import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import { AppContext } from "../../../../Context/AppContext";
import AppSettings from "../../../../Settings/AppSettings";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";

import Utils from "../../../../Common/Utils";

import Card from "Components/DesignSystem/Card/Card";
import Button from "Components/DesignSystem/Button/Button";
import Typography from "Components/DesignSystem/Typography/Typography";
import TextField from "Components/DesignSystem/TextField/TextField";
import { Cross, Refresh } from "Components/DesignSystem/Iconography/Icons";
import { toast } from "Components/DesignSystem/Toast/useToast";
import { uploadStatus } from "Components/GMS/Pdw/APIServices/Services";

let imageFilesArray = [];
let multipleFiles = [];

const ProductImages = ({ productID, productImages, setProductImages, setInitialDescriptionAndImages }) => {
  const { setProductImagesGlobal, setProductCount } = useContext(AppContext);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [urlImage, setUrlImage] = useState("");
  const [inputUrl, setInputUrl] = useState("");
  const [editPageNew, setEditPageNew] = useState(false);
  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {}, [editPageNew]);

  useEffect(() => {
    setProductImagesGlobal(productImages);
    setLoading({
      status: "",
      message: "",
    })
  }, [productImages]);

  async function addUrlImage() {

    if (inputUrl && !validURL(inputUrl)) {
      toast.error("Please enter valid image url");
      return;
    }

    if (handleImageValidation(inputUrl)) {
      let constDefault = await getImagesUrlToFile(inputUrl);
      let images = productImages.slice(0);
      images.push(constDefault);
      setProductImages(images);
      setUrlImage("");
      setInputUrl("");
    }
  }

  const handleImageValidation = async (imageURL) => {
    try {
      const response = await fetch(imageURL, { method: "HEAD" });
      if (
        response.ok &&
        response.headers.get("content-type").startsWith("image/")
      ) {
        return true;
      } else {
        toast.error("Please enter valid image url");
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  const getImagesUrlToFile = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        console.error('Failed to fetch image');
      }
      const blob = await response.blob();
      if (blob.size > 0 && blob.type.startsWith('image/')) {
        const imageExtension = blob.type.split('/')[1];
        const fileName = Utils.generate_file_name(10);
        return new File([blob], `${fileName}.${imageExtension}`, {
          type: blob.type,
          lastModified: new Date(),
        });
      } else {
        console.error('Invalid image');
      }
    } catch (error) {
      console.error('Error converting image URL to file:', error);
      return null;
    }
  }

  const onFileUpload = async (productImages) => {
    try {
      setDisableButton(true);
      if (productID === "0") {
        setProductImagesGlobal(productImages);
        setLoading({
          status: "Success",
          message: "images are saved",
        });
        return;
      }
  
      const formData = new FormData();
      if (productImages.length > 0) {
        productImages.map((file) => {
          formData.append("product_images", file, file.name);
          return null;
        });
        formData.append(
          "product_images_existing_count",
          productImages.length.toString()
        );
      }

      const response = await ServiceWrapper.doPost(
        `${api_base_url}product/${productID}/uploadimage`,
        formData,
        null,
        AuthManager.getGmsToken(),
        true
      );
      toast.info(response?.data?.message);
      checkUploadStatus(response?.data?.job_id, productImages);
    } catch (error) {
      console.error("onFileUpload ~ error:", error);
    }
  };

  const checkUploadStatus = async (jobId, productImages) => {
    try {
      const jobResponse = await uploadStatus(jobId);
      if (!jobResponse) {
        toast.error('Something went wrong, please try again');
        return;
      }
      if (jobResponse?.processing) {
        toast.info(jobResponse?.status);
        setTimeout(() => { checkUploadStatus(jobId); }, 2000);
        return;
      }
      if (jobResponse?.error) {
        toast.error(jobResponse?.status);
        setDisableButton(false);
        return;
      }
      toast.success(jobResponse?.message);
      setInitialDescriptionAndImages((prev) =>{ return  {...prev, images: productImages}});
      setDisableButton(false);
    } catch (error) {
      console.error(" checkUploadStatus ~ error:", error);
      setDisableButton(false);
    }
  }

  async function onMultipleChange(event) {
    let files = event.target.files;
    if (files && files.length > 0) {
      let images = productImages.slice(0);
      for (let i = 0; i < files.length; i++) {
        let file = files.item(i);
        images.push(file);
        if (isFileImage(file))
          multipleFiles.push({
            selectedFile: file,
          });
      }
      setProductImages(images);
      setUrlImage("");
    }
    setLoading({
      status: null,
      message: null,
    });
  }

  function isFileImage(file) {
    const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png"];
    return file && acceptedImageTypes.includes(file["type"]);
  }

  useEffect(() => {
    if (productID !== "0") {
      load_images();
    }
  }, [productID, editPageNew]);

  async function load_images() {
    setLoading({
      status: "Loading",
      message: "Loading product images",
    });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}product/${productID}/getuploadedimages`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (
        res.data.done &&
        res.data.data &&
        res.data.data.product_image_detail
      ) {
        if (res.data.data.product_image_detail !== "") {
          let final = JSON.parse(
            res.data.data.product_image_detail.replace(/'/g, '"')
          );
          if (final && final.length > 0 && final[0].JPEG_IMAGES) {
            const otherImages = final[0].JPEG_IMAGES.images;
            let constDefault = await getImagesUrlToFile(
              final[0].JPEG_IMAGES.default_image
            );
            let filesArray = [];
            filesArray.push(constDefault);
            await Promise.all(
              otherImages.map(async (elem) => {
                try {
                  const contents = await getImagesUrlToFile(elem);
                  filesArray.push(contents);
                } catch (error) {
                  console.log("error" + error);
                }
              })
            );
            setProductCount(filesArray.length);
            setProductImages(filesArray);
            setInitialDescriptionAndImages((prev) =>{
              return  {...prev, images: filesArray}
            })
          }
          multipleFiles = [];
          imageFilesArray = [];
          setUrlImage("");
          setLoading({
            status: "Success",
            message: undefined,
          });
        } else {
          setLoading({
            status: null,
            message: null,
          });
        }
      } else {
        setProductImages([]);
        // Must keep the {description, images} shape. This branch is the common "product has no
        // images" case -- the API returns product_image_detail: "", which is falsy, so it lands
        // here rather than on the `!== ""` check above. Assigning a bare [] made
        // initialDescriptionAndImages.images undefined, and Reset then fed that undefined
        // through setProductImages -> setProductImagesGlobal until CreateEditProduct read
        // .length off it and took the whole page down. Merge, never replace: `description`
        // belongs to LongDescription and must survive.
        setInitialDescriptionAndImages((prev) => ({ ...prev, images: [] }));
        setLoading({
          status: null,
          message: null,
        });
      }
    } else {
      setLoading({
        status: "Error",
        message: res.data && res.data.message ? res.data.message : "Error",
      });
    }
  }

  const handleUrlChange = (event) => {
    setInputUrl(event.target.value);
    if (event.target.value.trim() === "") setInputUrl("");
  };

  function validURL(str) {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" +
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
        "((\\d{1,3}\\.){3}\\d{1,3}))" +
        "(:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
        "(\\?[;&a-z\\d%_.~+=-]*)?" +
        "(#[-a-z\\d_]*)?$",
      "i"
    );
    return !!pattern.test(str);
  }

  const handle_delete_image = async (index) => {
    productImages.splice(index, 1);
    setProductImages(productImages.slice(0));
  };

  async function setDefaultImage(fromIndex, toIndex) {
    let element = productImages[fromIndex];
    productImages.splice(fromIndex, 1);
    productImages.splice(toIndex, 0, element);
    setProductImages(productImages.slice(0));
    await onFileUpload(productImages);
  }

  return (
    <Card className="tw-w-[890px] tw-ms-2.5" data-testid="product-images-panel">
      <div className="tw-flex tw-justify-between tw-w-full">
        <Typography className="tw-text-ink" variant="title-header" as="h3">Product Images</Typography>
          <div className="tw-flex tw-items-center tw-gap-2">
            {editPageNew ? (
              <>
                <Button variant="primary" data-testid="product-images-save-btn" disabled={disableButton} onClick={() => {
                  setUrlImage("");
                  onFileUpload(productImages);
                }}>Save</Button>
                <Button variant="secondary" data-testid="product-images-cancel-btn" onClick={() => {
                  setUrlImage("");
                  imageFilesArray.length = [];
                  multipleFiles = [];
                  setEditPageNew(false);
                }}>Cancel</Button>
              </>
            ) : (
              <>
                <Button
                  variant="secondary"
                  data-testid="product-images-add-btn"
                  onClick={() => {
                    setEditPageNew(true);
                  }}
                >
                  Add Image
                </Button>
                <Button
                  variant="subtle"
                  size="sm"
                  aria-label="Refresh"
                  data-testid="components-productimagesnew-button-1"
                  onClick={() => load_images(productID)}
                >
                  {/* DS Refresh (currentColor) — was `fa fa-sync-alt`, the second
                      icon family the DS glyph exists to replace. Inherits the
                      subtle Button's ink, so it already themed; now it also
                      matches every other refresh control's weight. */}
                  <Refresh aria-hidden="true" />
                </Button>
              </>
            )}
          </div>
        </div>
        <div className="row">
          <div
            className="pb-0 mb-0 col-10"
            style={{ overflowX: "scroll", overflowY: "hidden" }}
          >
            {productImages && productImages.length > 0 ? (
              <div
                className=" d-flex tw-gap-1 align-items-top"
                style={{ minHeight: "102px", manHeight: "102px" }}
              >
                {productImages.map((img, indx) => {
                  return (
                    <div
                      className="tw-align-items-center"
                      key={indx + img}
                      //style={{ height: "30px" }}
                    >
                      <div className="wrapper1">
                        <img
                          src={img ? URL.createObjectURL(img) : ''}
                          alt=""
                          style={{
                            width: "108px",
                            height: "108px",
                            objectFit: "cover",
                          }}
                        />

                        {editPageNew && (
                          <Button
                            variant="subtle"
                            size="sm"
                            aria-label="Remove image"
                            data-testid={`components-productimagesnew-button-2-${indx}`}
                            className="closeButton1"
                            onClick={async () => {
                              await handle_delete_image(indx);
                            }}
                          >
                            <Cross size={14} />
                          </Button>
                        )}
                      </div>
                      {!editPageNew && indx !== 0 && (
                        <Button
                          variant="secondary"
                          size="sm"
                          data-testid={`components-productimagesnew-button-3-${indx}`}
                          className="tw-ms-3 tw-mt-1"
                          onClick={async () => {
                            await setDefaultImage(indx);
                          }}
                        >
                          Set as default
                        </Button>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <Typography variant="body-primary" as="span" className="tw-text-ink-secondary">
                Images not available
              </Typography>
            )}
          </div>
          {editPageNew && (
            <div className="gap-2 mt-4 col-2 d-flex">
              <input data-testid="components-productimagesnew-input-4"
                className="bg-white border-0 shadow-none form-control custom-file-input"
                type="file"
                accept="image/png, image/gif, image/jpeg"
                id="formFile"
                multiple
                title="Choose Files"
                style={{
                  widows: 132,
                  overflow: "hidden",
                  color: "#091caa",
                  float: "right",
                }}
                onChange={onMultipleChange}
              />
            </div>
          )}
        </div>

        {editPageNew && (
          <div className="mt-0">
            <div className="tw-flex tw-items-end tw-gap-2">
              <TextField
                label="Image URL"
                data-testid="components-productimagesnew-input-5"
                value={inputUrl}
                placeholder="Enter URL"
                onChange={(value, e) => { if (e) handleUrlChange(e); }}
                className="tw-flex-1"
              />
              <Button
                variant="primary"
                data-testid="components-productimagesnew-button-6"
                onClick={addUrlImage}
              >
                Add
              </Button>
            </div>
            {urlImage && (
              <img
                className="tw-mt-1"
                src={urlImage}
                alt=""
                style={{ width: "108px", height: "108px" }}
              />
            )}
          </div>
        )}

        <div className="tw-mt-3">
          <LoadingSuccessErrorAlert loading={Loading} />
        </div>
    </Card>
  );
};
export default ProductImages;
